import { NgModule } from "@angular/core";
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatBadgeModule } from '@angular/material/badge';
import { MatChipsModule } from '@angular/material/chips';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_LOCALE } from "@angular/material/core";
import { MatMomentDateModule } from '@angular/material-moment-adapter';

@NgModule({

    imports:[
        MatToolbarModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatSidenavModule,
        MatIconModule,
        MatListModule,
        MatInputModule,
        MatFormFieldModule,
        MatCardModule,
        MatSelectModule,
        MatRadioModule,
        MatSnackBarModule,
        MatBadgeModule,
        MatMenuModule,
        MatChipsModule,
        MatGridListModule,
        MatTooltipModule,
        MatCheckboxModule,
        MatDialogModule,
        MatTableModule,
        MatTabsModule,
        MatProgressSpinnerModule,
        MatExpansionModule,
        MatProgressBarModule,
        MatAutocompleteModule,
        MatProgressBarModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatMomentDateModule,
    ],

    exports:[
        MatToolbarModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatSidenavModule,
        MatIconModule,
        MatListModule,
        MatInputModule,
        MatFormFieldModule,
        MatCardModule,
        MatSelectModule,
        MatRadioModule,
        MatSnackBarModule,
        MatBadgeModule,
        MatMenuModule,
        MatChipsModule,
        MatGridListModule,
        MatTooltipModule,
        MatCheckboxModule,
        MatDialogModule,
        MatTableModule,
        MatTabsModule,
        MatProgressSpinnerModule,
        MatExpansionModule,
        MatProgressBarModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        MatNativeDateModule,
    ],
    providers: [
        MatDatepickerModule,
        { 
            provide: MAT_DATE_LOCALE, useValue: 'pt-BR' 
        },
    ]
})

export class MaterialModule { }
